/**
 * Collections + lead pipeline client (Stage Z PR C).
 *
 * All calls are workspace-scoped server-side; the client never sends a workspace
 * id, so a manipulated collection or lead id cannot cross tenants.
 */
import { del, get, patch, post } from "@/lib/api";

const BASE = "/lead-collections";

export const listCollections = () => get(BASE);

export const collectionOptions = () => get(`${BASE}/options`);

export const createCollection = ({ name, description, icon, color }) =>
  post(BASE, { name, description: description || null, icon: icon || null, color: color || null });

export const updateCollection = (collectionId, fields) =>
  patch(`${BASE}/${encodeURIComponent(collectionId)}`, fields);

/** Deletes the folder and its memberships only — never the saved leads. */
export const deleteCollection = (collectionId) =>
  del(`${BASE}/${encodeURIComponent(collectionId)}`);

export const listCollectionItems = (collectionId, limit = 200) =>
  get(`${BASE}/${encodeURIComponent(collectionId)}/items?limit=${encodeURIComponent(limit)}`);

export const addToCollection = (collectionId, { walmartItemId, sourceKey }) =>
  post(`${BASE}/${encodeURIComponent(collectionId)}/items`, {
    walmart_item_id: String(walmartItemId || "").trim(),
    source_key: sourceKey || null,
  });

export const removeFromCollection = (collectionId, { walmartItemId, sourceKey }) => {
  const qs = sourceKey ? `?source_key=${encodeURIComponent(sourceKey)}` : "";
  return del(
    `${BASE}/${encodeURIComponent(collectionId)}/items/${encodeURIComponent(walmartItemId)}${qs}`,
  );
};

export const leadCollections = ({ walmartItemId, sourceKey }) => {
  const qs = sourceKey ? `?source_key=${encodeURIComponent(sourceKey)}` : "";
  return get(`/leads/${encodeURIComponent(walmartItemId)}/collections${qs}`);
};

/** Update a saved lead's pipeline status and/or note. */
export const updateLead = ({ walmartItemId, sourceKey, status, note }) => {
  const qs = sourceKey ? `?source_key=${encodeURIComponent(sourceKey)}` : "";
  const body = {};
  if (status !== undefined) body.status = status;
  if (note !== undefined) body.note = note;
  return patch(`/leads/${encodeURIComponent(walmartItemId)}${qs}`, body);
};

export const LEAD_STATUSES = [
  { key: "sourcing", label: "Sourcing" },
  { key: "review", label: "Under Review" },
  { key: "watch", label: "Watching" },
  { key: "purchased", label: "Purchased" },
  { key: "archived", label: "Archived" },
];

export const COLLECTION_ICONS = [
  "folder", "sparkles", "tag", "flame", "star", "package", "flask", "check",
];

export const COLLECTION_COLORS = [
  "emerald", "blue", "amber", "rose", "violet", "slate", "teal",
];
